import React from 'react';

const sanitizeHtml = require('../utilities/sanitize-html.js');

sanitizeHtml.defaults.allowedAttributes = {
  ...sanitizeHtml.defaults.allowedAttributes,
  a: ['href', 'name', 'target', 'rel'],
  '*': ['class']
};
sanitizeHtml.defaults.allowedTags = [
  ...sanitizeHtml.defaults.allowedTags,
  ...['h1', 'h2', 'h3', 'style', 'img']
];


function substituteSwaps(str, swaps = {}) {
  let parsedStr = str;
  Object.keys(swaps).forEach((item) => {
    const regex = new RegExp(`{${item}}`, 'g');
    parsedStr = parsedStr.replace(regex, swaps[item]);
  });
  return parsedStr;
}

function HtmlPart({ htmlString, extraClass = '', swaps, ommitBaseStyles = false, id }) {
  const classes = ommitBaseStyles ? extraClass : `c-html-part ${extraClass}`;
  return (
    <div
      id={id}
      className={classes}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(substituteSwaps(htmlString, swaps)) }}
    />
  );
}
export default HtmlPart;



// WEBPACK FOOTER //
// ./src/parts/HtmlPart.js